import React from "react";
import {
  Box,
  Collapse,
  Divider,
  Drawer,
  Typography,
  IconButton,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import PodcastVideoItem from "../PodcastVideoItem";
import { useDispatch } from "react-redux";
import { setMedia, setWatchType } from "../../../store/reducers/mediaSlice";
import { useIsMobile } from "../../../hooks/responsive";

const ListEpisodesDrawer = ({
  media,
  episodes,
  trailerItem,
  podcast,
  open,
  onClose,
  isMaximized,
  ...props
}) => {
  const isMobile = useIsMobile();
  const dispatch = useDispatch();

  const contentJSX = (
    <Box
      sx={{
        backgroundColor: (theme) => theme.palette.blackProLighter,
        height: "100%",
        maxWidth: "100vw",
        padding: 2,
      }}
    >
      <Box
        sx={{
          position: "sticky",
          top: 0,
          display: "flex",
          flexDirection: "column",
          zIndex: 10,
        }}
      >
        <Typography
          sx={{
            fontSize: "20px",
            color: "white",
          }}
        >
          Liste des épisodes
        </Typography>
        {(!isMaximized || isMobile) && (<IconButton
          onClick={onClose}
          sx={{
            color: "white",
            position: "absolute",
            right: "10px",
            backgroundColor: (theme) => theme.palette.videoColors.button,
            "&:hover": {
              backgroundColor: (theme) => theme.palette.videoColors.buttonHover,
            },
          }}
        >
          <Close />
        </IconButton>)}
        <Divider />
      </Box>
      <PodcastVideoItem
        podcast={podcast}
        item={trailerItem}
        variant={"column"}
        selected={media?.type === "trailer"}
        onClickWatch={() => {
          dispatch(setWatchType("watch"));
          dispatch(setMedia(trailerItem));
        }}
        canListen={false}
        sx={{
          color: "white",
        }}
      />
      {episodes.length > 0 &&
        episodes.map((video, index) => {
          return (
            <PodcastVideoItem
              key={index}
              podcast={podcast}
              variant={"column"}
              item={video}
              selected={media?.id === video.id}
              onClickWatch={() => {
                dispatch(setWatchType("watch"));
                dispatch(setMedia(video));
              }}
              onClickListen={() => {
                dispatch(setWatchType("listen"));
                dispatch(setMedia(video));
              }}
              sx={{
                color: "white",
              }}
            />
          );
        })}
    </Box>
  );

  if (isMaximized && !isMobile) {
    return (
      <Collapse
        in={open}
        orientation="horizontal"
        sx={{
          backgroundColor: (theme) => theme.palette.blackProLighter,
          height: "100%",
        }}
      >
        {contentJSX}
      </Collapse>
    );
  }

  return (
    <Drawer
      variant={open ? "temporary" : "persistent"}
      anchor={"right"}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundColor: (theme) => theme.palette.blackProLighter,
          maxWidth: "100vw",
        },
      }}
      {...props}
    >
      {contentJSX}
    </Drawer>
  );
};

export default ListEpisodesDrawer;
